import { ITypedReduxAction } from 'shared/map-search/types/redux/actionType';

export enum EEarlyAccessContactsActionType {
  RequestContactsAccessCheck = 'EARLY_ACCESS_CONTACTS/REQUEST_CONTACTS_ACCESS_CHECK',
}

export interface IRequestContactsAccessCheckPayload {
  offerId: number;
}

export type TRequestContactsAccessCheck = ITypedReduxAction<
  EEarlyAccessContactsActionType.RequestContactsAccessCheck,
  IRequestContactsAccessCheckPayload
>;

export type TEarlyAccessContactsActions = TRequestContactsAccessCheck;
